// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.forgot-container .forgot-logo {
  width: 130px;
  position: absolute;
  top: 50px;
  left: 50px;
}
.forgot-container .email-row {
  font-size: 14px;
  color: #365A64;
}
.forgot-container .forgot-box-wrapper {
  padding: 20px 60px;
  font-size: 15px;
}
.forgot-container .forgot-box-wrapper .forgot-box {
  background-color: #fff;
  border-radius: 10px;
  width: 490px;
  height: 300px;
  display: flex;
  padding: 20px 0;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
.forgot-container .forgot-box-wrapper .forgot-box .forgot-description {
  text-align: center;
  font-size: 14px;
  line-height: 17px;
  color: #365A64;
  width: 330px;
  padding: 20px 0;
}
.forgot-container .forgot-box-wrapper .forgot-box .forgot-input {
  border: 1px solid #D3E1ED;
  border-radius: 5px;
  padding: 14px;
  margin-bottom: 14px;
  width: 300px;
}
.forgot-container .forgot-box-wrapper .forgot-box .forgot-error {
  color: red;
  padding: 5px 0 20px 0;
  font-size: 13px;
}
.forgot-container .forgot-box-wrapper .forgot-box .forgot-success {
  color: blue;
  padding: 5px 0 20px 0;
  font-size: 13px;
}
.forgot-container .forgot-box-wrapper .forgot-box .forgot-button {
  cursor: pointer;
}
.forgot-container .forgot-box-wrapper .forgot-box .forgot-password-link {
  color: #03A9F4;
  width: 330px;
  font-size: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword/ForgotPassword.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AACF;AAEC;EACC,eAAA;EACA,cAAA;AAAF;AAGC;EACC,kBAAA;EACA,eAAA;AADF;AAGE;EACC,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AADH;AAGG;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AADJ;AAIG;EACC,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAFJ;AAKG;EACC,UAAA;EACA,qBAAA;EACA,eAAA;AAHJ;AAMG;EACC,WAAA;EACA,qBAAA;EACA,eAAA;AAJJ;AAOG;EACC,eAAA;AALJ;AAQG;EACC,cAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AANJ","sourcesContent":[".forgot-container {\n\tdisplay: flex;\n\theight: 100vh;\n\twidth: 100vw;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\n\t.forgot-logo {\n\t\twidth: 130px;\n\t\tposition: absolute;\n\t\ttop: 50px;\n\t\tleft: 50px;\n\t}\n\n\t.email-row {\n\t\tfont-size: 14px;\n\t\tcolor: #365A64;\n\t}\n\n\t.forgot-box-wrapper {\n\t\tpadding: 20px 60px;\n\t\tfont-size: 15px;\n\n\t\t.forgot-box {\n\t\t\tbackground-color: #fff;\n\t\t\tborder-radius: 10px;\n\t\t\twidth: 490px;\n\t\t\theight: 300px;\n\t\t\tdisplay: flex;\n\t\t\tpadding: 20px 0;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-around;\n\t\t\talign-items: center;\n\n\t\t\t.forgot-description {\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 17px;\n\t\t\t\tcolor: #365A64;\n\t\t\t\twidth: 330px;\n\t\t\t\tpadding: 20px 0;\n\t\t\t}\n\n\t\t\t.forgot-input {\n\t\t\t\tborder: 1px solid #D3E1ED;\n\t\t\t\tborder-radius: 5px;\n\t\t\t\tpadding: 14px;\n\t\t\t\tmargin-bottom: 14px;\n\t\t\t\twidth: 300px;\n\t\t\t}\n\n\t\t\t.forgot-error {\n\t\t\t\tcolor: red;\n\t\t\t\tpadding: 5px 0 20px 0;\n\t\t\t\tfont-size: 13px;\n\t\t\t}\n\n\t\t\t.forgot-success {\n\t\t\t\tcolor: blue;\n\t\t\t\tpadding: 5px 0 20px 0;\n\t\t\t\tfont-size: 13px;\n\t\t\t}\n\n\t\t\t.forgot-button {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t.forgot-password-link {\n\t\t\t\tcolor: #03A9F4;\n\t\t\t\twidth: 330px;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tcursor: pointer;\n\t\t\t\tuser-select: none;\n\t\t\t}\n\t\t}\n\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
